import { useState, useEffect } from 'react';

/**
 * Hook to detect and handle subdomain routing
 * Works with Cloudflare Pages middleware
 *
 * @returns {{ subdomain: string|null, filter: string|null, isSubdomainSite: boolean }}
 */
export function useSubdomain() {
  const [subdomain, setSubdomain] = useState(null);
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    const hostname = window.location.hostname;
    const detectedSubdomain = getSubdomain(hostname);
    setSubdomain(detectedSubdomain);

    // Map subdomain to filter
    switch (detectedSubdomain) {
      case 'premium':
        setFilter('premium');
        break;
      case 'team':
        setFilter('team');
        break;
      case 'custom':
        setFilter('custom');
        break;
      default:
        setFilter(null);
    }

    console.log('[useSubdomain] Detected:', {
      hostname,
      subdomain: detectedSubdomain,
      filter: filter
    });
  }, []);

  return {
    subdomain,
    filter,
    isSubdomainSite: subdomain !== null && subdomain !== 'www',
  };
}

/**
 * Extract subdomain from hostname (client-side)
 */
function getSubdomain(hostname) {
  // Localhost
  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return null;
  }

  // Pages preview
  if (hostname.includes('.pages.dev')) {
    const parts = hostname.split('.');
    if (parts.length > 3) {
      return parts[0];
    }
    return null;
  }

  // Production
  const parts = hostname.split('.');

  if (parts.length === 2) {
    return null; // cloudcarded.com
  }

  if (parts.length === 3) {
    const sub = parts[0];
    return sub === 'www' ? null : sub;
  }

  return null;
}

export default useSubdomain;
